module.exports = __webpack_public_path__ + "img/title.3522b441.svg";